<template>
  <div>
    <el-form class="login-container" label-position="left"
             label-width="0px">
      <h3 class="login_title">OP数据上报demo</h3>
      <el-form-item>
        <el-input type="text" v-model="input"
                  auto-complete="off" placeholder="ownerid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="input1"
                  auto-complete="off" placeholder="apiid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="input2"
                  auto-complete="off" placeholder="apikey"></el-input>
      </el-form-item>

      <el-form-item>
        <el-input type="text" v-model="input4"
                  auto-complete="off" placeholder="tid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="input5"
                  auto-complete="off" placeholder="pageId"></el-input>
      </el-form-item>
      <el-form-item>
        <!--        <el-select v-model="values" placeholder="上报类型">-->
        <!--          <el-option-->
        <!--            v-for="items in level"-->
        <!--            :key="items.value"-->
        <!--            :label="items.label"-->
        <!--            :value="items.value">-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </el-form-item>
      <el-button type="success" v-on:click="update">
        用户上报
      </el-button>
    </el-form>





  </div>
</template>

<script>
import sha1 from "js-sha1";
import {Base64} from "js-base64";
import axios from "axios";

export default {
  data() {
    return {
      input: '',
      input1:'',
      input2: '',
      input3:'',
      input4: '',
      input5:'',
      values:'',
      level: [{
        value: 'SUBMIT',
        label: '表单提交'
      }, {
        value: 'REACTIVATION',
        label: '自定义拉活'
      }, {
        value: 'ACTIVATION',
        label: '自定义激活'
      },
        {
          value: 'PAY',
          label: '自定义付费'
        },
        {
          value: 'RETENTION_1',
          label: '自定义次留'
        }],
    }
  },
  methods: {
    update() {
      let parms={
        oid:this.input,
        apiid:this.input1,
        apikey:this.input2,
        lbid:this.input3,
        tid:this.input4,
        pageId:this.input5

      }
      console.log(parms)
      this.PostMoeny(parms)
    },
    //用户上报
    async PostMoeny(parms){
      console.log(parms)
      let time1 = parseInt(new Date().getTime()) + '';
      time1=parseInt(time1/1000);
      let sign= sha1(parms.apiid + parms.apikey + time1);
      let token=Base64.encode(parms.oid + "," + parms.apiid + "," + time1 + "," + sign);



      const config = {
        headers:{
          'Authorization': "Bearer "+token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
        }
      };

      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v1/clue/sendData', {
          "ip":"127.0.0.1",
          "transformType":102,
          "ownerId": parms.oid,
          "pageId": parms.pageId,
          "tid": parms.tid,
          "lbid":"1_0_0"
        },config
      ).then(res => {
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success'
        });
      })

    },
  }
}
</script>

<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}
body{
  margin: 0px;
}
.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

</style>
<style scoped="scoped">
.btn-upload {
  z-index: 100;
  border-radius: 30px;
  box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
}

.el-upload {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdateOp2.vue